
import { defineComponent } from 'vue';
import { CustomerCoupon as TypeCustomerCoupon } from '@/repositories/couponRepository';

type Props = {
  error?: any;
  line?: {
    link: string;
    displayName: string;
    pictureUrl?: string;
  };
  errorCode?: number;
  result: {
    // CS-6461 抽選対応
    instantwin?: any;
    id?: string[];
  };
};

export default defineComponent({
  props: {
    error: {
      type: Object,
      default: () => null,
    },
    line: {
      type: Object,
      default: () => null,
    },
    errorCode: {
      type: Number,
      default: null,
    },
    result: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    return {};
  },
});
